"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TableHead_1 = __importDefault(require("@mui/material/TableHead"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const style_1 = require("./style");
function DynamicTableHead({ tableHeadCells }) {
    return (react_1.default.createElement(TableHead_1.default, null,
        react_1.default.createElement(TableRow_1.default, null, tableHeadCells.map((cell, i) => {
            return (react_1.default.createElement(style_1.THeadCell, { key: i, align: cell.align, width: cell.width, variant: "head" }, cell.name));
        }))));
}
exports.default = DynamicTableHead;
